export default function BookFooter() {
    const WHATSAPP_NUMBER = "+918178052636";
    const PHONE_DISPLAY = "8178052636";

    return (
        <>
            <footer className="bg-gray-950 text-white py-10 px-6 sm:px-12">
                <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* Company Info */}
                    <div>
                        <h2 className="text-xl font-bold mb-3 text-yellow-400">
                            AdvanceLaptopService
                        </h2>
                        <p className="text-sm text-gray-300 mb-4">
                            Convenient Home Service Delivered to Your Door in Delhi NCR.
                            Book in seconds with no visiting charges, no hidden fees, and instant confirmation — right from your Device.


                        </p>
                        <p className="text-sm text-gray-400">
                            © {new Date().getFullYear()} AdvanceLaptopService. All rights reserved.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-semibold mb-3 text-yellow-400">
                            Quick Links
                        </h3>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li>
                                <a href="#home" className="hover:text-yellow-400">
                                    Home
                                </a>
                            </li>
                            <li>
                                <a href="#services" className="hover:text-yellow-400">
                                    Services
                                </a>
                            </li>
                            <li>
                                <a href="#about" className="hover:text-yellow-400">
                                    About
                                </a>
                            </li>
                            <li>
                                <a href="#reviews" className="hover:text-yellow-400">
                                    Reviews
                                </a>
                            </li>
                            <li>
                                <a href="#contact" className="hover:text-yellow-400">
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="text-lg font-semibold mb-3 text-yellow-400">
                            Our Services
                        </h3>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li>Laptop Screens </li>
                            <li>Desktop </li>
                            <li>Laptop Batteries, Chargers</li>
                            <li>RAM, SSD</li>
                            <li> Power Supplies</li>
                            <li>Cooling Fan</li>
                            <li>Custom PC Builds</li>
                            <li>Pickup & Delivery Service</li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div id="contact">
                        <h3 className="text-lg font-semibold mb-3 text-yellow-400">
                            Contact Us
                        </h3>
                        <p className="text-sm text-gray-300 mb-2">📍 Delhi NCR, India</p>
                        <p className="text-sm text-gray-300 mb-2">
                            📞{" "}
                            <a
                                href={`tel:${WHATSAPP_NUMBER}`}
                                className="hover:text-yellow-400"
                            >
                                {PHONE_DISPLAY}
                            </a>
                        </p>
                        <p className="text-sm text-gray-300 mb-4">
                            💬{" "}
                            <a
                                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-yellow-400"
                            >
                                Chat on WhatsApp
                            </a>
                        </p>
                        <a href="#contact">
                            <button className="mt-2 px-4 py-2 bg-yellow-400 text-black font-semibold rounded hover:bg-yellow-300 transition">
                                Book Appointment
                            </button>
                        </a>
                    </div>
                </div>
            </footer>
        </>
    );
}
